module.exports = __webpack_public_path__ + "img/logo.f721123f.png";